import React, { SyntheticEvent } from 'react'
import { connect } from 'react-redux'
import { Heading3 } from '@chegg/fanta'
import { createDocumentGdrive } from '../actions/documents'
import { tagFunnel } from '../actions/tagmanager'
import { DispatchThunk } from '../actions/types'
import Icon from '../components/base/Icon'
import { GDRIVE } from '../util/dataTestIds'
import DocumentTextarea from './DocumentTextarea'
import DocumentUploadBtn from './DocumentUploadBtn'
import ErrorMessage from './ErrorMessages'
import styles, { p, marginBottomClass } from './UploadOptions.css'
import { WtaiUploadWidgetProps, CENTER, ButtonAttributes } from '../types'
import {
  selectDisplayLegal,
  selectHeadingClass,
  selectSubtextClass,
  selectUploadUiClass,
  selectButtonAttributes,
} from '../selectors/site'
import { StoreState } from '../reducer/types'
import { UploadGDriveButton } from '../styles'
import { LegalCopy } from '../components/LegalCopy'
import { GOOGLE_DRIVE_BUTTON_COPY, IMPORT_PAPER_COPY, HEADER_DEFAULT_COPY, SUBHEADER_DEFAULT_COPY } from '../constants'

type Props = Pick<WtaiUploadWidgetProps, 'headingText' | 'subheadingText' | 'pasteOnly' | 'alignText'>

interface DispatchProps {
  openCheckModal: (e: SyntheticEvent) => void
}

interface StateProps {
  initialized: boolean
  displayLegal: boolean
  headingClass: string
  subtextClass: string
  uploadUiClass: string
  buttonAttributes: ButtonAttributes
}

export type UploadOptionsProps = Props & DispatchProps & StateProps

export const UploadOptions: React.FunctionComponent<UploadOptionsProps> = ({
  openCheckModal,
  initialized,
  pasteOnly,
  headingText = HEADER_DEFAULT_COPY,
  subheadingText = SUBHEADER_DEFAULT_COPY,
  alignText = CENTER,
  displayLegal,
  headingClass,
  subtextClass,
  uploadUiClass,
  buttonAttributes,
}) => {
  const textAlignClass = styles[`align-${alignText}`]
  const hasSubText = subheadingText && subheadingText.length > 0

  return (
    <div className={uploadUiClass}>
      <Heading3 className={[!hasSubText && marginBottomClass, headingClass, textAlignClass].filter(c => !!c).join(' ')}>
        {headingText}
      </Heading3>
      <h4 className={[subtextClass, textAlignClass].join(' ')}>{subheadingText}</h4>
      {initialized && !pasteOnly && <ErrorMessage />}
      <form className={styles.uploadOptions}>
        <DocumentTextarea initialized={initialized} buttonAttributes={buttonAttributes} />
        <div className="paper-entry text-center">
          {!pasteOnly && <p className={p}>{IMPORT_PAPER_COPY}</p>}
          {!pasteOnly && (
            <div className={styles.uploadButtonsWrapper}>
              <DocumentUploadBtn buttonAttributes={buttonAttributes} />
              <UploadGDriveButton
                {...buttonAttributes}
                size="medium"
                disabled={!initialized}
                data-id="gDriveUpload"
                data-test-id={GDRIVE}
                onClick={(e: SyntheticEvent) => openCheckModal(e)}
              >
                <Icon name="google-drive" size="20" />
                <span>{GOOGLE_DRIVE_BUTTON_COPY}&trade;</span>
              </UploadGDriveButton>
            </div>
          )}
        </div>
      </form>
      {displayLegal && <LegalCopy />}
    </div>
  )
}

const mapStateToProps = (state: StoreState) => ({
  initialized: state.app.initialized,
  displayLegal: selectDisplayLegal(state),
  headingClass: selectHeadingClass(state),
  subtextClass: selectSubtextClass(state),
  uploadUiClass: selectUploadUiClass(state),
  buttonAttributes: selectButtonAttributes(state),
})

const mapDispatchToProps = (dispatch: DispatchThunk) => ({
  openCheckModal: (e: SyntheticEvent) => {
    e.preventDefault()
    dispatch(createDocumentGdrive())
    dispatch(tagFunnel('upload paper', 'on google drive'))
  },
})

export default connect<StateProps, DispatchProps>(
  // @ts-ignore
  mapStateToProps,
  mapDispatchToProps
)(UploadOptions)
